<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-indigo text-white">
        <div>
          لیست حواله های بارنامه شماره
          <q-badge align="top" color="red" text-color="white" :label="wayBillNumber"/>
        </div>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-card flat v-for="havaItem in lodash.orderBy(detailsItems,['State_Name','City_Name','Cs_Name','Sale_Num'])"
              :key="havaItem.Sale_Num">
        <q-card-section class="no-padding" :horizontal="!$q.screen.lt.md">
          <q-btn round flat icon="timeline" color="indigo" size="sm"
                 @click="showOrderTimeLine(havaItem)"/>
          <q-chip dense square color="purple" text-color="white" :label="havaItem.Sale_Num" clickable
                  @click="showHavaDetails(havaItem.Sale_Num)"
                  icon="pin"/>
          <q-space/>
          <q-chip dense square :label="havaItem.Cs_Name" clickable @click="getCustomerInfo(havaItem.Cs_ID)"
                  icon="pin"/>
          <q-space/>
          <q-chip dense square :label="havaItem.State_Name" icon="location_city"/>
          <q-chip dense square :label="havaItem.City_Name" icon="location_city"/>
          <q-separator color="teal"/>
        </q-card-section>
      </q-card>
    </q-card-section>

    <q-dialog
        maximized
        v-model="showHavaDetailsDialog">
      <HavaDetails :store_id="[1,2,3,4,5]" :sale-kind="1" :hava_num="selectedHavaNum"/>
    </q-dialog>

    <q-dialog v-model="customerInfoDialog" :maximized="$q.screen.lt.md">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>

    <q-dialog :maximized="$q.screen.lt.md" v-model="showTimeLineDialog">
      <OrderTimeLine :sale-num="selectedSaleNum"
                     :sale-date="selectedSaleDate"
                     :remain-ordered="false"/>
    </q-dialog>
  </q-card>
</template>

<script>
import HavaDetails from "@/components/customers/HavaDetails";
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import OrderTimeLine from "@/components/OrderTrace/OrderTimeLine";

export default {
  name: "WayBillItems",
  components: {OrderTimeLine, CustomerInfo, HavaDetails},
  props: {
    wayBillNumber: {
      type: Number,
      required: true
    },
    detailsItems: {
      type:Array,
      default: () => []
  }
  },
  data() {
    return {
      selectedCustomer: '',
      selectedHavaNum: '',
      customerInfoDialog: false,
      showHavaDetailsDialog: false,
      selectedSaleNum: undefined,
      selectedSaleDate: undefined,
      showTimeLineDialog: undefined
    }
  },
  methods: {
    ...mapActions({
      setCustomerInfo: 'Customers/get_customer_info',
    }),
    showOrderTimeLine(row) {
      this.selectedSaleNum = row.Order_Num;
      this.selectedSaleDate = row.Sale_Date
      this.showTimeLineDialog = true;
    },
    getCustomerInfo(id) {
      this.setCustomerInfo(id).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    showHavaDetails(Hava_Num) {
      this.selectedHavaNum = Hava_Num
      this.showHavaDetailsDialog = true;
    },
  }
}
</script>

<style scoped>

</style>